module.exports = __webpack_public_path__ + "img/locked-password-image.6298447b.svg";